<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <form id="rfq_form" @submit.prevent="confirm">
                <div class="card" v-if="rfq">
                    <div class="card-header pb-0">
                        <div class="d-flex justify-content-between">
                            <div class="d-grid gap-2 d-flex">
                                <button 
                                    class="btn btn-xs btn-outline-primary text-xs font-weight-normal m-0" 
                                    @click="edit = true"
                                    v-if="!edit && (rfq.type_of_procurement_value === 'direct_purchase' || rfq.type_of_procurement_value === 'direct_assignment') && rfq.state_value == 'draft'">
                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit RFQ
                                </button>
                                <template v-if="edit">
                                    <button type="submit" :class="'btn btn-xs btn-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        <i class="fa fa-save" aria-hidden="true" v-if="!loading"></i> 
                                        Save
                                    </button>
                                    <button type="button" @click="discardRFQ" class="btn btn-xs btn-outline-secondary text-xs font-weight-normal m-0">
                                        <i class="fa fa-times" aria-hidden="true"></i> Discard
                                    </button>
                                </template>
                                <button 
                                    type="button"
                                    @click="download"
                                    :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')" v-if="!edit">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                    <i class="fa fa-download" v-if="!loading"></i> Download
                                </button>
                            </div>
                            <argon-badge color="info" class="text-xxs align-self-center" v-if="rfq">{{ rfq.state }}</argon-badge>
                        </div>
                        <hr/>
                    </div>
                    <div class="card-body min-vh-50 pt-0" v-if="rfq">
                        <h5>{{ rfq.name }}</h5>
                        <div class="row">
                            <div class="col-sm-6">
                                <table class="text-sm" width="100%">
                                    <tbody>
                                        <tr>
                                            <td class="text-secondary align-top" width="30%">Vendor</td>
                                            <td class="fw-bold align-top">{{ rfq.partner_name }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-secondary align-top">Type of Procurement</td>
                                            <td class="fw-bold align-top">{{ rfq.type_of_procurement }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-secondary align-top">Currency</td>
                                            <td class="fw-bold align-top">{{ rfq.currency_name }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-6">
                                <table class="text-sm" width="100%">
                                    <tbody>
                                        <tr>
                                            <td class="text-secondary align-top" width="30%">Order Date</td>
                                            <td class="fw-bold align-top">{{ rfq.date_order }}</td>
                                        </tr>
                                        <tr v-if="edit">
                                            <td class="text-secondary align-top">Expected Arrival</td>
                                            <td class="fw-bold align-top">
                                            <Datepicker
                                                v-model="receipt_date" 
                                                format="dd MMMM yyyy"
                                                required
                                                />
                                            </td>
                                        </tr>
                                        <tr v-else>
                                            <td class="text-secondary align-top">Expected Arrival</td>
                                            <td class="fw-bold align-top">{{ rfq.date_planned }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="table-responsive p-0 mt-3">
                            <table class="table align-items-center mb-0">
                                <thead>
                                    <tr class="bg-light">
                                        <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">#</th>
                                        <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Product</th>
                                        <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Description</th>
                                        <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Quantity</th>
                                        <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Unit Price (Exclude VAT)</th>
                                        <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2" v-if="rfq.vendor_tax_identity_pkp">Taxes</th>
                                        <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="line,i in rfq_lines" :key="line.purchase_order_line_id">
                                        <td class="text-sm mb-0 ps-2">{{ i+1 }}</td>
                                        <td>
                                            <p class="text-sm mb-0">{{ line.product_name }}</p>
                                        </td>
                                        <td>
                                            <p class="text-sm mb-0">{{ line.name }}</p>
                                        </td>
                                        <td>
                                            <p class="text-sm mb-0">{{ line.product_qty }}</p>
                                        </td>
                                        <td>
                                            <input 
                                            :ref="'bidPrice' + line.purchase_order_line_id" 
                                            class="form-control form-control-sm mb-0" 
                                            type="number" 
                                            required=""
                                            step="any"
                                            @change="onchangePrice($event,i)"
                                            :value="line.price_unit_value"
                                            v-if="edit"/>
                                            <p class="text-sm text-end mb-0" v-else>{{ line.price_unit }}</p>
                                        </td>
                                        <td v-if="rfq.vendor_tax_identity_pkp">
                                          <div class="d-grid gap-2 d-flex">
                                            <argon-badge color="info" class="text-xxs align-self-center" v-for="tax,i in line.account_tax_ids" :key="i">{{ tax }}</argon-badge>
                                          </div>
                                        </td>
                                        <td>
                                            <p class="text-sm text-end mb-0 px-2">{{ line.price_subtotal }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md offset-md-8 px-4">
                                <table class="text-sm fw-bold" width="100%">
                                    <tbody>
                                        <template v-if="rfq.vendor_tax_identity_pkp">
                                          <tr>
                                              <td class="" width="50%">Untaxed Amount</td>
                                              <td class="text-end">{{ rfq.amount_untaxed }}</td>
                                          </tr>   
                                          <tr>
                                              <td class="">Amount Tax</td>
                                              <td class="text-end">{{ rfq.amount_tax }}</td>
                                          </tr>
                                        </template>
                                        <tr>
                                            <td class="border-top">Amount Total</td>
                                            <td class="border-top fw-bold text-end">{{ rfq.amount_total }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row mt-3" v-if="rfq_history.length > 0">
                            <div class="col-md">
                            <p class="text-secondary text-sm">RFQ Price History</p>
                            <div class="table-responsive p-0">
                                <table class="table align-items-center mb-0">
                                    <thead>
                                        <tr class="bg-light">
                                            <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">#</th>
                                            <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Product</th>
                                            <th class="text-uppercase text-xs fw-bolder opacity-7 text-end ps-2">Quantity</th>
                                            <th class="text-uppercase text-xs fw-bolder opacity-7 text-end ps-2">Price Before</th>
                                            <th class="text-uppercase text-xs fw-bolder opacity-7 text-end ps-2">Price After</th>
                                            <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Update Date</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="line,i in rfq_history" :key="i">
                                        <td class="text-sm mb-0 ps-2">{{ i+1 }}</td>
                                        <td>
                                        <p class="text-sm mb-0">{{ line.product_name }}</p>
                                        </td>
                                        <td>
                                        <p class="text-sm text-end mb-0">{{ line.quantity }}</p>
                                        </td>
                                        <td>
                                        <p class="text-sm text-end mb-0 text-danger">{{ line.price_before }}</p>
                                        </td>
                                        <td>
                                        <p class="text-sm text-end mb-0 text-success">{{ line.price_after }}</p>
                                        </td>
                                        <td>
                                        <p class="text-sm mb-0">{{ line.date_updated }}</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from '../components/ArgonBadge.vue'
const endpoint = require("../router/endpoint");

export default {
  name: "rfq-detail",
  data() {
    return {
      rfq: null,
      loading: false,
      receipt_date: null,
      edit: false, // true = editable, false = readonly
      rfq_lines: [],
      rfq_line_ids: [],
      rfq_history: [],
    };
  },
  components: {
    ArgonBadge
  },
  methods: {
    discardRFQ () {
      this.edit = false
      this.getRFQDetail();
      this.getRFQLines();
    },
    getRFQDetail() {
      this.loading = true
      this.axios
        .post(
          endpoint.RFQ_LIST,
          {
            purchase_id: parseInt(this.$route.params.id.split('_')[0]),
            partner_id: parseInt(localStorage.getItem('partner_id')),
            limit: 1,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.rfq = response.data.data[0];
            this.loading = false;
            if (this.rfq.date_planned) {
                this.receipt_date = new Date(this.rfq.date_planned)
            }
          } else {
            if (response.data.response_code !== "4000"){
            this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
            });}
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading = false;
          this.$router.replace('/rfq')
        });
    },
    getRFQLines() {
      this.rfq_lines = []
      this.loading = true
      this.axios
        .post(
        endpoint.PO_LINES,
        {
            purchase_id: parseInt(this.$route.params.id.split('_')[0]),
            partner_id: parseInt(localStorage.getItem('partner_id')),
            limit: 1000,
            offset: 0
        },
        {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        }
        )
        .then((response) => {
        if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
        } else if (response.data.response_code === "0000") {
            response.data.data.forEach(line => {
                line.price_unit_value = line.price_unit ? Number(line.price_unit.replace(/[^0-9.-]+/g,"")) : 0
            });
            this.rfq_lines = response.data.data
        } else {
          if (response.data.response_code !== "4000"){
            this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
            });}
            this.loading = false;
        }
        })
        .catch((e) => {
        this.loading = false;
        this.$notify({
            type: 'error',
            title: 'Something went wrong!',
            text: e.response.data.message || e,
            });
        });
    },
    getRFQHistory() {
      this.loading = true
      this.axios
        .post(
          endpoint.BIDDING_HISTORY,
          {
            bid_id: 0,
            purchase_id: parseInt(this.$route.params.id.split('_')[0]),
            partner_id: parseInt(localStorage.getItem('partner_id')),
            limit: 10000,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.rfq_history = response.data.data;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading = false;
          this.$router.replace('/rfq')
        });
    },
    confirm() {
      this.rfq_line_ids = []
      const month = this.receipt_date.getMonth() >= 9 ? (this.receipt_date.getMonth() + 1) : '0' + (this.receipt_date.getMonth() + 1)
      const day = this.receipt_date.getDate() < 10 ? ('0' + this.receipt_date.getDate()) : this.receipt_date.getDate()
      this.loading = true
      this.rfq_lines.forEach(line => {
        this.rfq_line_ids.push({
          'id': parseInt(line.purchase_order_line_id.split('_')[0]),
          'qty': line.product_qty,
          'uom_id': 1,
          'price_unit': parseFloat(this.$refs['bidPrice'+line.purchase_order_line_id].value),
          'remark': line.name
        })
      });
      const params = {
          purchase_id: parseInt(this.$route.params.id.split('_')[0]),
          partner_id: parseInt(localStorage.getItem('partner_id')),
          rfq_line_ids: this.rfq_line_ids,
          date_planned: this.receipt_date.getFullYear() + '-' + month + '-' + day + ' ' + this.receipt_date.getHours() + ':' + this.receipt_date.getMinutes() + ':' + this.receipt_date.getSeconds()
        }
      this.axios
      .post(
        endpoint.RFQ_UPDATE,
        params,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      )
      .then((response) => {
        if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
        } else if (response.data.response_code === "0000") {
          // success
          this.loading = false
          this.edit = false
          this.getRFQDetail()
          this.getRFQLines()
          this.getRFQHistory()
          this.$notify({
            type: 'success',
            title: 'Voila!',
            text: 'Successfully Update Bidding',
          });
        } else {
          // sys error
          this.loading = false;
          this.$notify({
            type: 'error',
            title: 'Oops!',
            text: response.data.message,
          });
        }
      })
      .catch((e) => {
        this.loading = false;
        this.$notify({
            type: 'error',
            title: 'Error!',
            text: e.response.data.message || e,
          });
      });
    },
    onchangePrice(event,index) {
      this.rfq_lines[index].price_unit_value = event.target.value
    },
    download () {
      this.loading = true
      this.axios
          .post(
          endpoint.DOWNLOAD,
          {
              partner_id: parseInt(localStorage.getItem('partner_id')),
              res_id: parseInt(this.$route.params.id.split('_')[0]),
              template_report: 'sdt_report_aladin.report_standard_po_menu'
          },
          {
              headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
              }
          }
          )
          .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
              const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
              const downloadLink = document.createElement("a");
              const fileName = this.rfq.name + ".pdf";
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
          } else {
              if (response.data.response_code !== "4000"){
              this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
              });
              }
          }
          this.loading = false
          })
          .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
              });
          });
  }
  },
  mounted() {
    this.getRFQDetail();
    this.getRFQLines();
    this.getRFQHistory();
  }
};
</script>

<style>

</style>